// src/utils/handleApiAction.js
export function makeToaster(enqueueSnackbar) {
  return (message, variant = 'default') =>
    enqueueSnackbar(message, {
      variant,
      autoHideDuration: 3000,
      anchorOrigin: { vertical: 'top', horizontal: 'center' },
    });
}

/**
 * Exécute une action API avec gestion unifiée des erreurs + auth.
 * @param {Object} p
 * @param {Function} p.action        - ex: saveTemplate(payload, { onAuthRequired })
 * @param {any}      p.payload       - données à envoyer
 * @param {Function} p.setLoading    - setter du state de chargement
 * @param {boolean} p.isLoading      - permet une garde douce (return silencieux).
 * @param {Function} p.onSuccess     - callback success (res -> void)
 * @param {String}   p.successMsg    - message succès
 * @param {Function} p.enqueueSnackbar
 * @param {Function} p.logout        - méthode de déconnexion
 */
export async function handleApiAction({
  action,          // (payload, { onAuthRequired }) => Promise<res>
  payload,
  setLoading,      // optional
  isLoading,       // optional boolean (state externe)
  onSuccess,       // optional (res) => void
  enqueueSnackbar, // required pour les toasts
  logout,          // optional
  successMsg,      // optional fallback
}) {
  const toast = makeToaster(enqueueSnackbar);

  // Garde douce : si on sait qu’on est déjà en cours → on ne fait rien
  if (isLoading) return;

  try {
    if (typeof setLoading === 'function') setLoading(true);

    const res = await action(payload, {
      onAuthRequired: async () => {
        toast('Session expirée. Veuillez vous reconnecter.', 'warning');
        if (typeof logout === 'function') await logout();
      },
    });

    if(!res?.alertError){
      if(res?.error) toast(res.message, 'error')
      else if(res?.message && res.message !== "") toast(res.message, 'success')
    }

    if (typeof onSuccess === 'function') onSuccess(res);

  } catch (e) {
    // mapping simple des codes déjà posés par tes intercepteurs axios
    if (!e?.response && !e?.code) e.code = 'NETWORK';

    if (e.code === 'NETWORK') {
      toast('Réseau indisponible. Vérifiez votre connexion.', 'error');
    } else if (e.code !== 'AUTH_REQUIRED') {
      // (AUTH_REQUIRED géré via onAuthRequired)
      toast(e?.message || 'Une erreur est survenue.', 'error');
    }
    console.error(e);

  } finally {
    if (typeof setLoading === 'function') {
      try { setLoading(false); } catch {}
    }
  }
}